
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoalibauginnovacabs() {



    const cardData =
    {
        keyword: ' Pune to Alibaug Innova Cab',
        heading: 'Prince Cabs: Pune to Alibaug Innova Cab',
        headingDescription: 'Prince Cabs provides dependable Pune to Alibaug Innova Cab services, ideal for family beach trips, weekend holidays, group travel, and corporate outings. Our spacious and well-maintained Innova and Innova Crysta vehicles ensure a comfortable and safe journey to Alibaug, known for its pristine beaches and coastal charm. With professional drivers, flexible schedules, and on-time pickups, we make your Pune to Alibaug travel smooth and worry-free. Experience reliability, affordability, and complete comfort with Prince Cabs’ trusted Innova cab service from Pune to Alibaug.',

        top: 'Top Places to Visit in Alibaug with Prince Cabs',

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "Alibaug Beach is the most popular beach in the town, offering stunning sunset views over the Arabian Sea. The beach is wide, clean, and perfect for evening walks, horse cart rides, and local snacks. From here, visitors can enjoy a clear view of the historic Kolaba Fort, accessible during low tide. The beach is lively during weekends and festivals, attracting families and tourists from Mumbai and Pune. Its proximity to the town makes it the first stop for most travelers. Alibaug Beach blends leisure, history, and coastal charm."
  },
  {
    "title": "Kolaba Fort",
    "description": "Kolaba Fort, built by Chhatrapati Shivaji Maharaj in the 17th century, is a sea fort located about 2 km from Alibaug shore. Accessible on foot during low tide or by boat during high tide, the fort features strong walls, cannons, temples, and freshwater wells. It served as a strategic naval base for the Marathas. Visitors enjoy exploring its ruins and learning about its history. The fort’s sea-facing views are spectacular. It is a must-visit for history lovers and adventure seekers."
  },
  {
    "title": "Varsoli Beach",
    "description": "Varsoli Beach is a quieter alternative to Alibaug Beach, known for its clean white sands and calm waters. The beach is lined with coconut and suru trees, creating a serene environment. It is popular for water sports like jet skiing and parasailing. The beachside resorts and homestays make it a peaceful weekend retreat. Sunsets here are mesmerizing and less crowded compared to the main beach. Varsoli is ideal for families, couples, and those seeking tranquility."
  },
  {
    "title": "Nagaon Beach",
    "description": "Nagaon Beach, located 7 km from Alibaug, is famous for its wide stretch of sand and adventure activities. Visitors can enjoy banana boat rides, parasailing, and speed boating here. The beach is surrounded by palm and betel nut plantations, adding to its scenic charm. It is also known for its seafood stalls and beach shacks. The lively atmosphere makes it a favorite among groups of friends and young travelers. Nagaon is one of Alibaug’s most happening beaches."
  },
  {
    "title": "Kihim Beach",
    "description": "Kihim Beach is a pristine and eco-friendly spot located about 12 km from Alibaug. Known for its soft sands, dense coconut groves, and biodiversity, it attracts nature lovers and photographers. The beach is famous for rare butterflies, birds, and flowers. Homestays and resorts nearby provide authentic Konkani hospitality. The beach is less commercialized, making it ideal for peaceful getaways. Kihim is a favorite for those who want to escape crowds and enjoy natural beauty."
  },
  {
    "title": "Kanakeshwar Forest & Temple",
    "description": "Kanakeshwar Temple, located on a hill about 12 km from Alibaug, is dedicated to Lord Shiva. To reach it, visitors must climb nearly 700 steps through a dense forest, making the journey adventurous. The temple complex is surrounded by lush greenery and offers panoramic views of the Arabian Sea. The forest is home to rare plants and small wildlife, adding a natural charm. The temple is spiritually significant and attracts devotees during festivals like Mahashivratri. It is a blend of spirituality and trekking adventure."
  },
  {
    "title": "Akshi Beach",
    "description": "Akshi Beach is a hidden gem located just 5 km from Alibaug. Known for its crystal-clear waters and long sandy stretch, it is perfect for solitude and relaxation. Birdwatchers often visit to spot migratory seabirds along the shoreline. The calm atmosphere makes it popular among couples and families looking for quiet time. Fishing villages nearby add a rustic charm. Akshi Beach is a peaceful escape compared to the busier beaches of Alibaug."
  },
  {
    "title": "Mandwa Beach",
    "description": "Mandwa Beach is a lively coastal spot best known for its adventure water sports and as the gateway to Alibaug via ferry from Mumbai. The beach is dotted with shacks, eateries, and luxury villas. Visitors enjoy activities like parasailing, jet skiing, and kayaking. Its proximity to Mumbai makes it a quick weekend escape. The beach offers spectacular views of Mumbai’s skyline on clear days. Mandwa is both adventurous and stylish, making it a top choice for tourists."
  },
  {
    "title": "Revdanda Fort & Beach",
    "description": "Revdanda Fort, built by the Portuguese in the 16th century, lies in ruins but still showcases tall walls and bastions. The fort is located right by the Revdanda Beach, making it a picturesque combination of history and coastal scenery. The black sand beach is quiet and less crowded, ideal for photography and picnics. Visitors enjoy exploring the fort ruins covered in wild greenery. It is a perfect offbeat destination for history lovers. Revdanda combines heritage with natural charm."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort, located about 50 km from Alibaug, is one of India’s strongest sea forts, built on an island in the Arabian Sea. Known as the ‘invincible fort,’ it was never conquered despite repeated attacks. The fort has 19 bastions, freshwater lakes, and palaces. Visitors reach it via short boat rides from Rajapuri. The fort is a marvel of medieval defense architecture. It is a must-visit for history enthusiasts and adventurers exploring the Konkan coast."
  }
],


"services": [
    {
        "name": "Pune to Alibaug Cab",
        "description": "Book a comfortable and scenic cab ride from Pune to Alibaug, one of Maharashtra’s favorite beach destinations. Whether you're planning a weekend trip, a beach holiday, or just a peaceful getaway, our reliable cab service ensures a smooth journey with experienced drivers and well-maintained vehicles."
    },
    {
        "name": "Pune to Alibaug Cab Service",
        "description": "Enjoy a hassle-free travel experience with our Pune to Alibaug cab service. We provide timely pickups, clean and AC-enabled vehicles, and trained chauffeurs familiar with the coastal route. Perfect for solo travelers, couples, and families heading to Alibaug for relaxation or events."
    },
    {
        "name": "Pune to Alibaug Taxi Service",
        "description": "Our taxi service from Pune to Alibaug offers safe and convenient transportation with flexible travel options. Choose from a variety of vehicles—sedans, SUVs, and premium cars—to match your group size and budget. Ideal for leisure trips, beach vacations, or business travel."
    },
    {
        "name": "Pune to Alibaug Cab Booking",
        "description": "Book your Pune to Alibaug cab in just a few clicks with our quick and easy online booking system. Get instant confirmations, transparent pricing, and 24/7 support. Whether it’s a planned trip or last-minute travel, we’re ready to serve with the best cab options."
    },
    {
        "name": "Pune to Alibag Dzire Cab Booking",
        "description": "Choose a Swift Dzire cab for your Pune to Alibaug journey if you're looking for an economical yet comfortable ride. With air conditioning, ample legroom, and smooth handling, this sedan is ideal for small families or solo travelers wanting comfort at an affordable price."
    },
    {
        "name": "Pune to Alibaug Innova Cab",
        "description": "Book an Innova or Innova Crysta cab from Pune to Alibaug for group travel or family outings. These spacious and premium SUVs offer a relaxed travel experience with plenty of legroom, luggage space, and AC comfort—perfect for long journeys through scenic coastal roads."
    },
    {
        "name": "Pune to Alibaug Round Trip Taxi",
        "description": "Plan your full-day or weekend trip with our round trip taxi from Pune to Alibaug. The vehicle stays with you for the entire journey, giving you flexibility to explore beaches, forts, and restaurants in Alibaug before returning comfortably and safely to Pune."
    },
    {
        "name": "Pune to Alibaug Family Cab",
        "description": "Travel with your loved ones from Pune to Alibaug in our specially selected family cabs. Spacious interiors, safety features, and courteous drivers make this a perfect choice for vacations, reunions, or family functions by the beach. Child-friendly seating and extra luggage space available."
    },
    {
        "name": "Pune to Alibaug Affordable Taxi",
        "description": "Looking for a budget-friendly option to travel from Pune to Alibaug? Our affordable taxi service provides reliable vehicles, fuel-included rates, and no hidden charges. Ideal for quick trips or cost-conscious travelers who don’t want to compromise on comfort and safety."
    },
    {
        "name": "Pune to Alibaug Etios Cab",
        "description": "Travel in a Toyota Etios from Pune to Alibaug for a comfortable and fuel-efficient ride. The Etios is ideal for small families or couples and provides a smooth driving experience with ample space and reliable AC, making your coastal trip enjoyable and relaxed."
    }
],
"tableData": [
    ["Pune to Alibaug Cab", "Pune to Alibaug Cab Service"],
    ["Pune to Alibaug Taxi Service", "Pune to Alibaug Cab Booking"],
    ["Pune to Alibag Dzire Cab Booking", "Pune to Alibaug Innova Cab"],
    ["Pune to Alibaug Round Trip Taxi", "Pune to Alibaug Family Cab"],
    ["Pune to Alibaug Affordable Taxi", "Pune to Alibaug Etios Cab"]
],


"whychoose": [
    {
        "WhyChooseheading": "Premium Pune to Alibaug Innova Cab Service",
        "WhyChoosedescription": "Prince Cabs offers a luxurious and reliable Pune to Alibaug cab service featuring spacious Toyota Innova vehicles, perfect for families, groups, and corporate travelers. Enjoy a comfortable, smooth ride along the scenic coastal route, whether you’re heading to Alibaug’s beaches, forts, or resorts, with professional service and timely pickups."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Innova Interiors",
        "WhyChoosedescription": "Our Innova cabs provide ample legroom, ergonomic seating, and large windows for scenic views, ensuring a relaxing journey during the approximately 150 km trip. Equipped with clean, air-conditioned cabins and sufficient luggage space, our vehicles cater to both short trips and extended travel with ease."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Safe and Courteous Driving",
        "WhyChoosedescription": "Our professional drivers are well-versed in the Pune to Alibaug route, including expressways and ferry points, ensuring safe, smooth, and timely travel. Courteous and knowledgeable, they provide a hassle-free experience, suggesting convenient stops or scenic viewpoints if you wish."
    },
    {
        "WhyChooseheading": "Flexible Booking for One-Way, Round-Trip, or Full-Day Rentals",
        "WhyChoosedescription": "Whether you need a quick one-way transfer, a round trip for a beach day, or a full-day cab for Alibaug sightseeing, Prince Cabs offers customizable packages. You can book effortlessly via phone, website, or WhatsApp, with options to tailor the itinerary as per your schedule and preferences."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "Each Innova vehicle is thoroughly cleaned and sanitized before and after every trip to ensure passenger safety and comfort. Our fleet undergoes regular maintenance, and we equip vehicles with essential safety features such as seat belts, GPS tracking, and first-aid kits to guarantee a secure ride."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Multiple Secure Payment Methods",
        "WhyChoosedescription": "Our Pune to Alibaug Innova cab service offers competitive, upfront pricing with no hidden fees. We accept various payment methods including UPI, credit/debit cards, net banking, and cash, making booking and payment seamless and trustworthy."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for a Smooth Travel Experience",
        "WhyChoosedescription": "Our customer care team is available 24/7 to assist you with bookings, route planning, and any travel-related queries. From pickup to drop-off, we ensure your journey from Pune to Alibaug is convenient, enjoyable, and hassle-free."
    }
]



















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Alibaug Innova cab services?',
        answer: 'Yes, Prince Cabs provides comfortable and spacious Toyota Innova cabs from Pune to Alibaug, ideal for families, groups, and beach getaways.',
    },
    {
        question: 'Why choose an Innova for the Pune to Alibaug trip?',
        answer: 'Innova is perfect for long-distance travel—it offers ample legroom, luggage space, AC, and a smooth ride, making it a great choice for the scenic Pune to Alibaug route.',
    },
    {
        question: 'Is the Innova suitable for group or family travel to Alibaug?',
        answer: 'Absolutely! Our Innova cabs can comfortably accommodate 6–7 passengers, making them ideal for families, friends, or weekend group trips to Alibaug.',
    },
    {
        question: 'Can I customize my Pune to Alibaug itinerary with stopovers?',
        answer: 'Yes, you can request stopovers at popular points like Karnala Fort, Kashid Beach, or eateries en route to Alibaug.',
    },
    {
        question: 'What are the charges for a Pune to Alibaug Innova cab?',
        answer: 'Pricing depends on travel dates, duration, and route preferences. Contact Prince Cabs for a customized and competitive quote for Innova bookings.',
    },
    {
        question: 'How do I book a Pune to Alibaug Innova cab with Prince Cabs?',
        answer: 'Simply call us or book via our website. Share your travel details and preferences, and we’ll arrange the best Innova cab for your journey.',
    },
    {
        question: 'Are your Innova cabs clean and well-maintained?',
        answer: 'Yes, all Innova cabs are regularly cleaned, sanitized, and serviced to ensure a safe, smooth, and enjoyable ride.',
    },
];

const testimonials = [
    {
        name: "Mr. Tejas Rane",
        position: "Group Traveler",
        text: "We booked an Innova from Pune to Alibaug with Prince Cabs. The car was super clean and comfortable, and the driver was very polite and professional.",
        image: "/img/testimonial/testimonial-thumb-alibaug-1.png",
    },
    {
        name: "Mrs. Manasi Apte",
        position: "Family Vacationer",
        text: "Our Pune to Alibaug beach trip in an Innova from Prince Cabs was perfect. The vehicle had plenty of space, and the ride was smooth and relaxing.",
        image: "/img/testimonial/testimonial-thumb-alibaug-2.png",
    },
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibaug Innova Cab",
  "image": "https://princecab.com/assets/images/pune-alibaug-innova-cab.jpg",
  "description": "Book Pune to Alibaug Innova cab with Prince Cabs for comfortable, reliable, and affordable taxi service. Available for round trips, family travel, and quick bookings. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-alibaug-innova-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Alibaug Innova Cab | Reliable & Affordable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Alibaug Innova cab service for reliable and affordable travel. Perfect for family trips, round trips, and quick taxi bookings. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Alibaug Cab, Pune to Alibaug Cab Service, Pune to Alibaug Taxi Service, Pune to Alibaug Cab Booking, Pune to Alibag Dzire Cab Booking, Pune to Alibaug Innova Cab, Pune to Alibaug Round Trip Taxi, Pune to Alibaug Family Cab, Pune to Alibaug Affordable Taxi, Pune to Alibaug Etios Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalibauginnovacabs;